import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
// import { useNavigate } from "react-router-dom";
import logo from "../../assets/stride-logo.png";
import { useAuth0 } from "@auth0/auth0-react";
// import WebNotificationBar from "../Notification/WebNotificationBar";
import { useNotificationContext } from "../../contexts/NotificationContext";
import { useContentfulContext } from "../../contexts/ContentfulContext";

const WebNavbar = () => {
    const { content } = useContentfulContext();
    const { auth } = useContext(AuthContext);
    const { getNotificationData } = useNotificationContext();
    const { loginWithRedirect } = useAuth0();
    // const navigate = useNavigate();

    // const logoutHandler = () => {
    //   window.localStorage.removeItem("user_internal_id");
    //   setAuth({
    //     user_name: "",
    //     user_email: "",
    //     user_verification: false,
    //     user_loggedIn: false,
    //   });
    //   navigate("/");
    // };

    const handleLogin = () => {
        loginWithRedirect({
            authorizationParams: {
                redirect_uri: process.env.REACT_APP_AUTH0_BASE_URL,
            },
        });
    };

    useEffect(() => {
        getNotificationData();
    }, []);

    return (
        <>
            {/* <WebNotificationBar/> */}
            <header className="border shadow-md popins-fonts">
                <div className="px-4 border-grey">
                    <div className="flex items-center justify-between py-5">
                        <div className="w-auto pr-2">
                            <a href="#" className="w-28 inline-block">
                                <img src={logo} alt="Stride Logo" />
                            </a>
                        </div>
                        <div className="w-auto font-medium">
                            <div className="flex flex-wrap items-center">
                                <div className="w-auto hidden lg:block">
                                    <ul className="flex gap-10 items-center capitalize font-medium">
                                        <li className="">
                                            <Link to="https://stridetech.io/">
                                                {content.WEB_NAVBAR?.home}
                                            </Link>
                                        </li>
                                        <li className="">
                                            <Link to="https://stridetech.io/pricing/">
                                                {content.WEB_NAVBAR?.pricing}
                                            </Link>
                                        </li>
                                        <li
                                            className={`relative mr-8  text-black `}
                                        >
                                            <Link to="https://stridetech.io/contact/">
                                                {content.WEB_NAVBAR?.contact}
                                            </Link>
                                        </li>
                                        {/* <li className="">
                    <Link to="/about">{content.WEB_NAVBAR?.about}</Link>
                  </li>
                  <li className="">
                    <Link to="/help">{content.WEB_NAVBAR?.help}</Link>
                  </li> */}
                                        {/* <li className={`relative mr-8  text-black `}>
                    <Link to="/about">{content.WEB_NAVBAR?.useful_links}</Link>
                    <div className="invisible absolute left-[-100%] right-[-100%] mt-4 z-50 flex w-68 flex-col bg-secondary py-1 px-4 text-gray-800 shadow-xl group-hover:visible">
                      <Link
                        to="/adobe-spark"
                        class="my-2 block border-b border-gray-100 py-1 text-gray-500 hover:text-black md:mx-2"
                      >
                        {content.WEB_NAVBAR?.adobe_community_page}
                      </Link>
                      <Link
                        to="/sample-size"
                        class="my-2 block border-b border-gray-100 py-1 text-gray-500 hover:text-black md:mx-2"
                      >
                        {content.WEB_NAVBAR?.sample_size_calculator}
                      </Link>
                      <a className="my-2 block border-b border-gray-100 py-1 text-gray-500 hover:text-black md:mx-2">
                        {content.WEB_NAVBAR?.adobe_target_knowledge_repository}
                      </a>
                      <a className="my-2 block border-b border-gray-100 py-1 text-gray-500 hover:text-black md:mx-2">
                        {content.WEB_NAVBAR?.adobe_target_commands_cheat_sheet}
                      </a>
                    </div>
                  </li> */}
                                        {/* { !auth.user_loggedIn && <li className=" text-black tracking-tight"><Link to="/">Login</Link></li> } */}
                                    </ul>
                                </div>
                                <div className="w-auto flex justify-center items-center">
                                    {!auth.user_loggedIn && (
                                        <div className="flex gap-4 items-center ">
                                            <button
                                                onClick={handleLogin}
                                                className="border border-primary py-2 px-8 rounded-lg capitalize"
                                            >
                                                {content.WEB_NAVBAR?.login}
                                            </button>
                                            <Link
                                                to="https://stridetech.io/demo/"
                                                className="bg-primary text-white px-8 py-2 rounded-lg capitalize"
                                            >
                                                {content.WEB_NAVBAR?.book_demo}{" "}
                                            </Link>
                                        </div>
                                    )}
                                    {/* { auth.user_loggedIn && <Link className="inline-block px-5 py-3 text-white text-center tracking-tight bg-primary hover:bg-indigo-600 rounded-lg focus:ring-4 focus:ring-indigo-300 transition duration-200" to="/account">Dashboard</Link> } */}
                                    {/* { auth.user_loggedIn && <div class="ml-4 relative inline-block text-left">
                  <div class="relative cursor-pointer w-10 h-10 overflow-hidden bg-gray-100 rounded-full" onClick={handleProfile}>
                    <svg class="absolute w-12 h-12 text-gray-400 -left-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"></path></svg>
                  </div>
                  { showProfile && <div class="absolute right-0 z-10 mt-4 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                    <div class="py-1" role="none">
                      <a href="#" class="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-0">Account settings</a>
                      <a href="#" class="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-1">Support</a>
                      <form method="POST" action="#" role="none">
                        <button type="submit" class="text-gray-700 block w-full px-4 py-2 text-left text-sm" role="menuitem" tabindex="-1" id="menu-item-3" onClick={logoutHandler}>Log out</button>
                      </form>
                    </div>
                  </div> }
                </div> } */}
                                    {/* <div class="flex items-center justify-between">
                  <div class="flex items-center"> */}
                                    {/* {<div class="flex items-center ml-3 relative">
                        <div>
                          <button type="button" class="relative w-12 h-12 overflow-hidden bg-gray-100 rounded-full block" onClick={() => setShowProfile(!showProfile)}>
                            <svg class="w-12 h-12 rounded-full" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"></path></svg>
                          </button>
                        </div>
                        { showProfile && <div class="z-50 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow absolute top-full right-[-5px] w-40">
                          <ul class="py-1" role="none">
                            <li>
                              <Link to="/dashboard/profile" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">Profile</Link>
                            </li>
                            <li>
                              <Link to="/dashboard/company" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">Company</Link>
                            </li>
                            <li>
                              <Link to="/dashboard/manage-users" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">Manage User</Link>
                            </li>
                            <li>
                              <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">Log out</a>
                            </li>
                          </ul>
                        </div> }
                      </div> } */}
                                    {/* </div>
                </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default WebNavbar;
